import React from 'react';

import {
    Close,
    Visibility,
    VisibilityOff,
    AccountCircleRounded,
    ManageAccountsOutlined,
    PaymentOutlined,
    SettingsOutlined,
    LogoutOutlined,
    Replay,
    AlternateEmailOutlined,
    PhoneAndroidOutlined,
    LocationOnOutlined,
    BusinessOutlined,
    BadgeOutlined,
    PublicOutlined,
    ChevronLeft,
    CreditCardOffOutlined,
    VerifiedUserOutlined,
    LockOutlined,
    FilterAltOff,
    FilterAlt,
    Search,
    SearchOff,
    LanguageOutlined,
    AccessTimeOutlined,
    ModeEdit,
    FiberManualRecord,
    SortOutlined,
    SouthOutlined,
    NorthOutlined,
    Circle,
    InfoOutlined,
    MoneyOff,
    Speed,
    NewReleases,
    SupportAgent,
    TrendingUp,
    SimCardDownload,
    UploadFile,
    ToggleOn,
    ToggleOff,
    MoreVert,
    Category,
    Groups,
    Hotel,
    Payment,
    Add,
    Edit,
    Delete,
    ContentCopy,
    Info,
    DateRange,
    Face,
    ChildCare,
    ChildFriendly,
    Girl,
    Face3,
    Preview,
    Error,
    ReportProblem,
    NotInterested,
    Message,
    Email,
    Person,
    Event,
    Apartment,
    StickyNote2,
    Battery0Bar,
    Battery6Bar,
    Battery4Bar,
    Battery1Bar,
    Today,
    ContentPaste,
    Assignment,
    EditCalendar,
    Newspaper,
    EventNote,
    Bed,
    GppBad,
    Payments,
    Paid,
    Restaurant,
    Star,
    StarHalf,
    StarOutline,
    Description,
    DryCleaning,
    List,
    CardMembershipOutlined,
    RadioButtonUnchecked,
    CircleOutlined,
    CheckCircle,
    OpenInNew,
    AutoFixHigh,
    AddPhotoAlternate,
    ViewInAr,
    RoomService,
    People,
    Fastfood,
    Image,
    MeetingRoom,
    KeyboardArrowDown,
    KeyboardArrowUp,
    InsertChartOutlined,
    ListAlt,
    RequestQuote,
    DoDisturb,
    Badge,
    PhoneAndroid,
    LocationOn,
    Work,
    AccountBalance,
    Receipt,
    CreditCard,
    FormatListBulleted,
    Language,
    AccessTime,
    ColorLens,
    Calculate,
    FormatAlignCenter,
    InsertDriveFileOutlined,
    CloudUpload,
    KeyboardArrowLeft,
    KeyboardArrowRight,
    Send,
    Pending,
    FiberManualRecordOutlined,
    Schema,
    Cable,
    Link,
    LinkOff,
    ArrowForward,
    ArrowBack,
    Luggage,
    Business,
    Hub,
    AccountTree,
    CorporateFare,
    CalendarMonth,
    ViewList,
    ReceiptLong,
    AddCircleOutline,
    Album,
    PercentOutlined,
    MoneyOutlined,
    MoreHoriz,
    Nightlight,
    AlbumOutlined,
    PinOutlined,
    PendingOutlined,
    HorizontalRule,
    AutoGraph,
    ShowChart,
    BarChartOutlined,
    ExpandMore,
    ExpandLess,
    ChevronRight,
    SellOutlined,
    LibraryAdd,
    Comment,
    CalendarToday,
    TableChartOutlined,
    CalendarMonthOutlined,
    PointOfSale,
    PlaylistAddCheckOutlined,
    PlaylistAddOutlined,
    StorefrontOutlined,
    FamilyRestroom,
    Wc,
    StopCircle,
    GroupAdd,
    Checklist,
    Check,
    Key,
    Wifi,
    WaterDropOutlined,
    Flatware,
    AutoAwesomeOutlined,
    WarningAmberOutlined,
    WarningOutlined,
    ErrorOutlineOutlined,
    DeleteOutlined,
    Laptop,
    Tablet,
    Smartphone,
    SpeakerNotesOff,
    SpeakerNotesOffOutlined,
    SendOutlined,
    SaveOutlined,
    Pause,
    StarBorder,
    PlayArrowOutlined,
    CloudUploadOutlined,
    Public,
    PublicOff,
    WarningAmber,
    ArrowUpward,
    ArrowDownward,
    ImageOutlined,
    FileUploadOutlined,
    CropSquare,
    ZoomIn,
    Contrast,
    ImageNotSupportedOutlined,
    CloudDone,
    CloudOff,
    VisibilityOutlined,
    Fullscreen,
    FullscreenExit,
    Clear,
    LeaderboardOutlined,
    PermContactCalendar,
    EmailOutlined,
    StickyNote2Outlined,
    CheckBox,
    IndeterminateCheckBoxOutlined,
} from '@mui/icons-material';
import Tooltip from './Tooltip';
import Excel from '../images/excel.svg';

const Icon = props => {
    const { iconName, titleText, tooltipProps, ...restProps } = props;
    const icons = {
        Close,
        Visibility,
        VisibilityOff,
        VisibilityOutlined,
        AccountCircleRounded,
        ManageAccountsOutlined,
        PaymentOutlined,
        SettingsOutlined,
        LogoutOutlined,
        Replay,
        AlternateEmailOutlined,
        PhoneAndroidOutlined,
        LocationOnOutlined,
        BusinessOutlined,
        BadgeOutlined,
        Badge,
        PublicOutlined,
        ChevronLeft,
        CreditCardOffOutlined,
        VerifiedUserOutlined,
        LockOutlined,
        FilterAltOff,
        FilterAlt,
        Search,
        SearchOff,
        LanguageOutlined,
        AccessTimeOutlined,
        ModeEdit,
        FiberManualRecord,
        SortOutlined,
        SouthOutlined,
        NorthOutlined,
        Circle,
        InfoOutlined,
        MoneyOff,
        Speed,
        NewReleases,
        SupportAgent,
        TrendingUp,
        SimCardDownload,
        UploadFile,
        ToggleOn,
        ToggleOff,
        MoreVert,
        Category,
        Groups,
        Hotel,
        Payment,
        Add,
        Edit,
        Delete,
        ContentCopy,
        Info,
        DateRange,
        Face,
        ChildCare,
        ChildFriendly,
        Girl,
        Face3,
        Preview,
        Error,
        ReportProblem,
        NotInterested,
        Message,
        Email,
        Person,
        Event,
        Apartment,
        StickyNote2,
        Battery0Bar,
        Battery6Bar,
        Battery4Bar,
        Battery1Bar,
        Today,
        ContentPaste,
        Assignment,
        EditCalendar,
        Newspaper,
        EventNote,
        Bed,
        GppBad,
        Payments,
        Paid,
        Restaurant,
        Star,
        StarHalf,
        StarOutline,
        Description,
        DryCleaning,
        List,
        CardMembershipOutlined,
        RadioButtonUnchecked,
        CircleOutlined,
        CheckCircle,
        OpenInNew,
        AutoFixHigh,
        AddPhotoAlternate,
        ViewInAr,
        RoomService,
        People,
        Fastfood,
        Image,
        MeetingRoom,
        KeyboardArrowDown,
        KeyboardArrowUp,
        InsertChartOutlined,
        ListAlt,
        RequestQuote,
        DoDisturb,
        PhoneAndroid,
        LocationOn,
        Work,
        AccountBalance,
        Receipt,
        CreditCard,
        FormatListBulleted,
        Language,
        AccessTime,
        ColorLens,
        Calculate,
        FormatAlignCenter,
        InsertDriveFileOutlined,
        CloudUpload,
        KeyboardArrowLeft,
        KeyboardArrowRight,
        Send,
        Pending,
        FiberManualRecordOutlined,
        Schema,
        Cable,
        Link,
        LinkOff,
        ArrowForward,
        ArrowBack,
        Luggage,
        Business,
        Hub,
        AccountTree,
        CorporateFare,
        CalendarMonth,
        ViewList,
        ReceiptLong,
        AddCircleOutline,
        Album,
        PercentOutlined,
        MoneyOutlined,
        MoreHoriz,
        Nightlight,
        AlbumOutlined,
        PinOutlined,
        PendingOutlined,
        HorizontalRule,
        AutoGraph,
        ShowChart,
        BarChartOutlined,
        ExpandMore,
        ExpandLess,
        ChevronRight,
        SellOutlined,
        LibraryAdd,
        Comment,
        CalendarToday,
        TableChartOutlined,
        CalendarMonthOutlined,
        PointOfSale,
        PlaylistAddCheckOutlined,
        PlaylistAddOutlined,
        StorefrontOutlined,
        FamilyRestroom,
        Wc,
        StopCircle,
        GroupAdd,
        Checklist,
        Check,
        Key,
        Wifi,
        WaterDropOutlined,
        Flatware,
        AutoAwesomeOutlined,
        WarningAmberOutlined,
        WarningOutlined,
        ErrorOutlineOutlined,
        DeleteOutlined,
        Excel,
        Laptop,
        Tablet,
        Smartphone,
        SpeakerNotesOff,
        SpeakerNotesOffOutlined,
        SendOutlined,
        SaveOutlined,
        Pause,
        StarBorder,
        PlayArrowOutlined,
        CloudUploadOutlined,
        Public,
        PublicOff,
        WarningAmber,
        ArrowUpward,
        ArrowDownward,
        ImageOutlined,
        FileUploadOutlined,
        CropSquare,
        ZoomIn,
        Contrast,
        ImageNotSupportedOutlined,
        CloudDone,
        CloudOff,
        Fullscreen,
        FullscreenExit,
        Clear,
        LeaderboardOutlined,
        PermContactCalendar,
        EmailOutlined,
        StickyNote2Outlined,
        CheckBox,
        IndeterminateCheckBoxOutlined,
    };

    const IconComponent = icons[iconName];

    const awesomeFontClassName = `${iconName} ${restProps?.className}`;

    const icon = () => {
        if (IconComponent) {
            return <IconComponent fontSize='small' {...restProps} />;
        }
        return <i {...restProps} className={awesomeFontClassName} />;
    };

    if (titleText)
        return (
            <Tooltip titleText={titleText} {...tooltipProps}>
                {icon()}
            </Tooltip>
        );
    return <>{icon()}</>;
};

export default Icon;
